export const DATE_TIME_SUFFIX = "Z"

export const BLANK = ""
